var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartTreeMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 1.52381C0.904297 0.682233 1.58653 0 2.42811 0H7.28525C8.12683 0 8.80906 0.682233 8.80906 1.52381V5.90476C8.80906 6.74634 8.12683 7.42857 7.28525 7.42857H2.42811C1.58653 7.42857 0.904297 6.74634 0.904297 5.90476V1.52381Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95192 1.52381C9.95192 0.682233 10.6341 0 11.4757 0H17.571C18.4125 0 19.0948 0.682233 19.0948 1.52381V3.04762C19.0948 3.8892 18.4125 4.57143 17.571 4.57143H11.4757C10.6341 4.57143 9.95192 3.8892 9.95192 3.04762V1.52381Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95192 7.2381C9.95192 6.39652 10.6341 5.71429 11.4757 5.71429H17.571C18.4125 5.71429 19.0948 6.39652 19.0948 7.2381V8.7619C19.0948 9.60348 18.4125 10.2857 17.571 10.2857H11.4757C10.6341 10.2857 9.95192 9.60348 9.95192 8.7619V7.2381Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95192 12.9524C9.95192 12.1108 10.6341 11.4286 11.4757 11.4286H17.571C18.4125 11.4286 19.0948 12.1108 19.0948 12.9524V14.4762C19.0948 15.3178 18.4125 16 17.571 16H11.4757C10.6341 16 9.95192 15.3178 9.95192 14.4762V12.9524Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 10.0952C0.904297 9.25366 1.58653 8.57143 2.42811 8.57143H7.28525C8.12683 8.57143 8.80906 9.25366 8.80906 10.0952V14.4762C8.80906 15.3178 8.12683 16 7.28525 16H2.42811C1.58653 16 0.904297 15.3178 0.904297 14.4762V10.0952Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTreeMap);
export default __webpack_public_path__ + "static/media/chart-tree-map.98c2d7fdaf0dd9b8e46ad104ab6b46c8.svg";
export { ForwardRef as ReactComponent };